import { globalPlaybackSlice } from "./slice";

export const { togglePlayback } = globalPlaybackSlice.actions;
